import React from 'react';
import {observer} from 'mobx-react';
import './moulding.scss';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    width: number;
    height: number;
    store: FrameBuilderStore;
};

export const Moulding = observer(({store, width, height}: Props) => {
    const {frame, inchToPx} = store;
    const {mouldingThickness, cornerTopLeftURL, cornerTopRightURL, cornerBottomLeftURL, cornerBottomRightURL, sideLeftURL, sideTopURL, sideBottomURL, sideRightURL} = frame.moulding;

    return (
        <div
            id="moulding"
            style={{
                gridTemplateColumns: `${inchToPx(mouldingThickness)} ${inchToPx(width)} ${inchToPx(mouldingThickness)}`,
                gridTemplateRows: `${inchToPx(mouldingThickness)} ${inchToPx(height)} ${inchToPx(mouldingThickness)}`,
            }}
        >
            <img
                src={cornerTopLeftURL}
                alt="Moulding Top Left"
            />
            <img
                src={sideTopURL}
                alt="Moulding Top"
            />
            <img
                src={cornerTopRightURL}
                alt="Moulding Top Right"
            />
            <img
                src={sideLeftURL}
                alt="Moulding Left"
            />
            <div />
            <img
                src={sideRightURL}
                alt="Moulding Right"
            />
            <img
                src={cornerBottomLeftURL}
                alt="Moulding Bottom Left"
            />
            <img
                src={sideBottomURL}
                alt="Moulding Bottom"
            />
            <img
                src={cornerBottomRightURL}
                alt="Moulding Bottom Right"
            />
        </div>
    );
});
